import React, { Component } from 'react'

import Button from '../../../../../components/Button'
import Modal from '../../../../../components/Modal'
import CheckboxGroup from '../../../components/CheckboxGroup'
import { PERMISSION_OPTIONS } from '../../../shared/static-options'

class BatchEditLuftUserPermissionsModal extends Component {

    constructor(props) {
		super(props)

		this.state = {
            permissionOptions: [...PERMISSION_OPTIONS]
        }
    }
 
    _handlePermissionChange = (updatedOptions) => {
        this.setState({
            permissionOptions: updatedOptions
        })
    }

    _savePermissions = () => {
        // TODO
    }

    render() {
        const { onDismiss, userDataList } = this.props
        const { permissionOptions } = this.state

        return (
            <Modal
                title={"Editar permissões"}
                size={"small"}
                onBackdropClick={onDismiss}
            >
                <div className="luft-edit-permissions-modal-content">
                    <div className="luft-edit-permissions-modal-form-section">
                        <div className="luft-edit-permissions-modal-form-section-label">Usuários selecionados</div>
                        <div className="luft-edit-permissions-modal-form-selected-users">
                        {
                            userDataList && userDataList.map((user, index) => {
                                return (
                                    <div key={index} className="luft-edit-permissions-modal-form-user-pill">
                                        {user.name}
                                    </div>
                                )
                            })
                        }
                        </div>
                    </div>

                    <CheckboxGroup
                        label="Configurar permissões"
                        options={permissionOptions}
                        onChange={this._handlePermissionChange}              
                    />

                    <div className="luft-edit-permissions-modal-footer">
                        <Button skin={"secondary"} text={"CANCELAR"} onClick={onDismiss} />
                        <Button skin={"primary"} text={"SALVAR"} onClick={this._savePermissions} />
                    </div>
                </div>
            </Modal>
        )
    }
}

export default BatchEditLuftUserPermissionsModal
